var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDefaultAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "61px",
    viewBox: "0 0 52 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-defaultAvatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-signUp",
    transform: "translate(-1001.000000, -350.000000)",
    fill: "#E5E5E5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(851.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(120.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-defaultAvatar",
    transform: "translate(30.461538, 25.384615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7049477,49.4555769 L49.4356829,44.3786538 C48.8334762,41.9157512 47.0077181,39.9350571 44.6018664,39.1346484 L35.2938913,36.0334615 C33.0239897,35.0878846 31.9853741,31.4325 31.7610712,30.0447746 C33.4906429,28.6065775 34.6035303,26.5603395 34.87077,24.32689 C34.8325929,23.9454267 34.9226314,23.5620793 35.1267054,23.2374339 C35.4565159,23.1548347 35.7265321,22.9186388 35.8522687,22.6028185 C36.4613175,21.128131 36.8435843,19.5697536 36.9861783,17.9807362 C36.9864758,17.894369 36.9758655,17.8083984 36.9544467,17.7248077 C36.8029282,17.1073468 36.4398986,16.56247 35.9284246,16.1847746 L35.9284246,10.576857 C35.9284246,7.16897236 34.8876274,5.77073618 33.7917958,4.96051082 C33.5825654,3.31903846 31.8246336,6.01228469e-15 25.3513831,6.01228469e-15 C19.6082573,0.231237981 15.0053874,4.83398438 14.7741433,10.5769561 L14.7741433,16.1848738 C14.2626692,16.5625691 13.8996396,17.1074459 13.7481211,17.7249069 C13.7267023,17.8084976 13.716092,17.8945673 13.7163895,17.9808353 C13.8587852,19.570646 14.241052,21.1297175 14.8502991,22.6050992 C14.9419242,22.9040625 15.1821921,23.1340114 15.4849316,23.2122476 C15.6034293,23.2714453 15.8255507,23.5782422 15.8255507,24.3270883 C16.094377,26.566884 17.2137099,28.6177825 18.952206,30.0555829 C18.7300847,31.4411268 17.6977163,35.0944291 15.491377,36.0167037 L6.10089981,39.1347476 C3.69693209,39.9350571 1.87236392,41.913768 1.26926481,44.3745883 L-3.00614234e-14,49.4515114 C-3.00614234e-14,52.4303812 7.75181984,60.1721157 24.5057118,60.1721157 C41.2596038,60.1721157 50.7049477,52.6173491 50.7049477,49.4555769 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultAvatar);
export default __webpack_public_path__ + "static/media/ic-defaultAvatar.2bbab291142f036c892244fcb0a23b85.svg";
export { ForwardRef as ReactComponent };